import { Question } from "../../models/RestModels";

export function getEmptyQuestion(): Question
{
		return {
			id: 0,
			form_id: 0,
			question: '',
			priority: 1,
			required: 0,
			help: '',
			options: null,
			type: 'text',
			status: 'ACTIVE',
			created: new Date(),
			updated: new Date()
		}
}
